module.exports = __webpack_public_path__ + "0945ac469c88d88aee7b4273efb4039a.gif";